/*----------------------------------------------------------------------------------------------
 *  Archivo que maneja fetch para todos los requerimientos de solicitud
 *  de datos al servidor
 -----------------------------------------------------------------------------------------------*/

/*
 *  Esta función recibe los siguientes datos:
 *      - un objeto con:
 *          - url: dirección completa que incluye direccion y slashes
 *          - method: el metodo a utilizarse.  Por default es 'POST' porque se utiliza más que los otros
 *          - token: el token del usuario, default '' (vacio)
 *          - body: el cuerpo del mensaje, por defecto null
 *      - dispatch: funcion dispatch
 */ 
const fetchData = async ({url, method='POST', token='', body=null}, dispatch) => {
    //console.log('fetchData: ', {method, token, body});
    //En el header se incluye authorization sólo si se recibe token, de lo contario sólo se envia el content-type
    const headers = token ? { 'content-type':'application/json', authorization: `Bearer ${token}`}
                    : { 'content-type':'application/json', authorization: `Bearer ${token}`}
    //El body se envía stringifyed si se recibe, de lo contrario se envía un objeto nulo
    body = body ? {body: JSON.stringify(body)} : {};
    //console.log({body})
    try {
        const response = await fetch(url, {method, headers, ...body});
        const data = await response.json();
        if(!data.success){
            //console.log('error data: ', data);
            //Verifica si el motivo de no success es por usuario no autorizado, de ser así, lo desloguea
            if(response.status === 401) {
                dispatch({type: 'UPDATE_USER', payload: null});
                throw new Error(data.message);
            }
            throw new Error(data.message);
        }
        //console.log('respuesta: ', data.result);
        //return data.result; //Se devuelven los resultados en caso de éxito
        return data; //Se devuelven los resultados en caso de éxito
    } catch (error) {
        dispatch({type: 'UPDATE_ALERT', payload: {open: true, severity: 'error', message: error.message}});
        //console.log(error);
        return null;    //Se devuelve nulo en caso de error
    }
}

export default fetchData;